// import Component from './index';

export default {
  // component: Component,
  component: load(() => import(/* webpackChunkName: "CustomPrint" */ './index')),
  priority: 9,
  permissions: ['Dashboard'],
  name: 'CustomPrint',
  icon: 'printer',
  drawer: true,
};

